import { useState } from 'react';

import { useStaticQuery, Link, graphql } from 'gatsby';

import * as styles from './NavBar.module.scss';

import { ReactComponent as Logo } from '../../assets/svg/logo.svg';

const isPartiallyActive = ({ isPartiallyCurrent }) => {
	return isPartiallyCurrent ? { className: styles.current } : {};
};

const PartialNavLink = (props) => (
	<Link getProps={isPartiallyActive} {...props} />
);

export default function Navbar() {
	const { site, i18NJson: i18n } = useStaticQuery(graphql`
		query {
			site {
				siteMetadata {
					title
				}
			}
			i18NJson {
				ui {
					homeBack
					about
					portfolio
					testimonials
					blog
					contact
				}
			}
		}
	`);

	const [isOpen, setIsOpen] = useState(false);

	return (
		<nav className={styles.navbar}>
			<div className={styles.navbarWrapper}>
				<div className={styles.brand}>
					<Link
						to={'/'}
						title={i18n.ui.homeBack}
						className={styles.brandLink}
					>
						<span className="sr-only">
							{site.siteMetadata.title}
						</span>
						<Logo className={styles.logo} />
					</Link>
				</div>
				<button
					className={styles.hamburger}
					onClick={() => setIsOpen(!isOpen)}
					aria-label="Toggle menu"
				>
					<span className={styles.bar}></span>
					<span className={styles.bar}></span>
					<span className={styles.bar}></span>
				</button>
				<div
					className={`${styles.navLinks} ${isOpen ? styles.open : ''}`}
				>
					<header>
						<h2>Navigation</h2>
						<button
							className={styles.close}
							onClick={() => setIsOpen(!isOpen)}
							aria-label="Toggle menu"
						>
							<span className={styles.closeBar}></span>
							<span className={styles.closeBar}></span>
						</button>
					</header>
					<ul>
						<li>
							<PartialNavLink
								to={
									process.env.GATSBY_PAGES_ABOUT_SLUG ||
									'/about/'
								}
								onClick={() => setIsOpen(!isOpen)}
							>
								{i18n.ui.about}
							</PartialNavLink>
						</li>
						<li>
							<PartialNavLink
								to={
									process.env.GATSBY_PAGES_PORTFOLIO_SLUG ||
									'/portfolio/'
								}
								onClick={() => setIsOpen(!isOpen)}
							>
								{i18n.ui.portfolio}
							</PartialNavLink>
						</li>
						<li>
							<PartialNavLink
								to={
									process.env
										.GATSBY_PAGES_TESTIMONIALS_SLUG ||
									'/testimonials/'
								}
								onClick={() => setIsOpen(!isOpen)}
							>
								{i18n.ui.testimonials}
							</PartialNavLink>
						</li>
						<li>
							<PartialNavLink
								to={
									process.env.GATSBY_PAGES_BLOG_SLUG ||
									'/blog/'
								}
								onClick={() => setIsOpen(!isOpen)}
							>
								{i18n.ui.blog}
							</PartialNavLink>
						</li>
						<li>
							<PartialNavLink
								className={styles.contact}
								to={
									process.env.GATSBY_PAGES_CONTACT_SLUG ||
									'/contact/'
								}
								onClick={() => setIsOpen(!isOpen)}
							>
								{i18n.ui.contact}
							</PartialNavLink>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	);
}
